import*as t from"react";const e=()=>{const[e,r]=t.useState(!1);return t.useEffect((()=>{r(!0)}),[]),e};export{e as useIsClient};
//# sourceMappingURL=use-is-client.js.map
